// 🚧 Moved here during app separation and slightly refactored.
import { SeoHeaderData } from '@finn/ui-cosmic';
import { config } from '@finn/ui-utils';
import get from 'lodash/get';
import Head from 'next/head';
import React from 'react';

import { parseBoolean } from './parseBoolean';

type Props = {
  seoHeader: {} | SeoHeaderData;
  canonicalUrl?: string;
  isNoIndexNoFollow?: boolean;
};

const HeadTags: React.FunctionComponent<Props> = ({
  seoHeader = {},
  canonicalUrl,
  isNoIndexNoFollow,
}) => {
  const noIndexParamExist = typeof isNoIndexNoFollow !== 'undefined';
  const isNoIndex = noIndexParamExist
    ? isNoIndexNoFollow
    : parseBoolean(get(seoHeader, 'metadata.no_index', ''));

  const description = get(seoHeader, 'metadata.og_description', '');

  return (
    <Head>
      <title>{get(seoHeader, 'metadata.title', '')}</title>
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta name="description" content={description} />
      <meta name="keywords" content={get(seoHeader, 'metadata.keywords', '')} />
      <meta name="google-site-verification" content={config.GMC_TAG} />
      {isNoIndex && (
        <>
          <meta name="robots" content="noindex,follow" />
          <meta name="googlebot" content="noindex,follow" />
        </>
      )}
      <meta
        property="og:title"
        content={get(seoHeader, 'metadata.og_title', '')}
      />
      <meta
        property="og:type"
        content={get(seoHeader, 'metadata.og_type', '')}
      />
      <meta property="og:url" content={get(seoHeader, 'metadata.og_url', '')} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content={get(seoHeader, 'metadata.og_image.url', '')}
      />
      <meta
        property="og:image:secure_url"
        content={get(seoHeader, 'metadata.og_image_secure_url.url', '')}
      />
      <meta
        property="og:image:url"
        content={get(seoHeader, 'metadata.og_image_url.url', '')}
      />
      <meta
        property="og:image:type"
        content={get(seoHeader, 'metadata.og_image_type', '')}
      />
      <meta
        property="og:image:width"
        content={get(seoHeader, 'metadata.og_image_width', '')}
      />
      <meta
        property="og:image:height"
        content={get(seoHeader, 'metadata.og_image_height', '')}
      />
      <meta
        property="og:site_name"
        content={get(seoHeader, 'metadata.og_site_name', '')}
      />
    </Head>
  );
};

export default HeadTags;
